import type { ReactElement } from 'react';
import { components, type GroupBase, type OptionProps, type SingleValueProps } from 'react-select';
import type { DropdownOption } from '../utils/optionTransformers';
import { VehicleTypeRowWithIcon } from './VehicleTypeRowWithIcon';

export const VehicleTypeDropdownOption = <TValue extends DropdownOption<unknown>>({
  children,
  ...optionProps
}: OptionProps<TValue, false, GroupBase<TValue>>): ReactElement<OptionProps<TValue, false>> => (
  <components.Option {...optionProps}>
    <VehicleTypeRowWithIcon vehicleTypeCode={optionProps.data.value} children={children} />
  </components.Option>
);

export const VehicleTypeDropdownSingleValue = <TValue extends DropdownOption<unknown>>({
  children,
  ...optionProps
}: SingleValueProps<TValue, false, GroupBase<TValue>>): ReactElement<SingleValueProps<TValue>> => (
  <components.SingleValue {...optionProps}>
    <VehicleTypeRowWithIcon vehicleTypeCode={optionProps.data.value} children={children} />
  </components.SingleValue>
);
